
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import {
  DocumentAdded,
  DocumentRemoved,
  DocumentModified
} from './document.actions';
import { ShowErrorMessage } from '../notification/notification.actions';
import {
  WithoutMeta,
  FireStoreDocument
} from '@digitaix/types';

@Injectable({
  providedIn: 'root'
})
export class DocumentService<D extends FireStoreDocument, Query> {
  public basePath: string;

  public buildPath(path: string): string {
    return path;
  }

  public buildCollectionPath(path: string): string {
    return path;
  }

  public load(collectionPath: string, query?: Query): Observable<D[]> {
    return throwError('[DocumentService::load] Not implemented');
  }

  public subscribe(
    collectionPath: string,
    query?: Query
  ): Observable<
    DocumentAdded<D> | DocumentRemoved | DocumentModified<D> | ShowErrorMessage
  > {
    return throwError('[DocumentService::subscribe] Not implemented');
  }

  public create(
    collectionPath: string,
    document: WithoutMeta<D>,
    documentId?: string
  ): Observable<D> {
    return throwError('[DocumentService::create] Not implemented');
  }

  public delete(
    collectionPath: string,
    documentId: string
  ): Observable<boolean> {
    return throwError('[DocumentService::delete] Not implemented');
  }

  public update(
    collectionPath: string,
    documentId: string,
    document: Partial<WithoutMeta<D>>
  ): Observable<D> {
    return throwError('[DocumentService::update] Not implemented');
  }

  public get(collectionPath: string, documentId: string): Observable<D | null> {
    return throwError('[DocumentService::get] Not implemented');
  }

  public getMany(
    collectionPath: string,
    documentIds: string[]
  ): Observable<D[]> {
    return throwError('[DocumentService::getMany] Not implemented');
  }

  public reset(removeLoadedDocuments: boolean = true): void {}

  public init(): Promise<any> {
    return null;
  }
}
